import { render, staticRenderFns } from "./TaskDistributions.vue?vue&type=template&id=5a97dff2&scoped=true"
import script from "./TaskDistributions.vue?vue&type=script&lang=js"
export * from "./TaskDistributions.vue?vue&type=script&lang=js"
import style0 from "./TaskDistributions.vue?vue&type=style&index=0&id=5a97dff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97dff2",
  null
  
)

export default component.exports